import React, { FunctionComponent } from 'react';
import {
  II18n,
  I18nService,
  BrassTextField,
  BrassTextFieldProps,
} from '../../../../';

const translations: II18n = {
  es: {
    costcenterLabel: 'Centro de costos',
  },
  enUS: {
    costcenterLabel: 'Cost Center',
  },
  ptBR: {
    costcenterLabel: 'Centro de Custo',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

const CostCenterField: FunctionComponent<BrassTextFieldProps> = (
  props: BrassTextFieldProps,
) => (
  <BrassTextField
    {...props}
    name='costcenter'
    label={translate('costcenterLabel')}
  />
);

export { CostCenterField };
